import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paragraph: {
    whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'normal', lineBreak: 'strict',
    textAlign: 'start', textAlignLast: 'start', lineHeight: 1.9, margin: theme.spacing(3, 0),
  },
  link: {
    overflowWrap: 'anywhere', wordBreak: 'break-all', textDecoration: 'underline', textDecorationThickness: '1px', textUnderlineOffset: '0.16em',
    '&:hover, &:focus-visible': { color: theme.palette.primary.main, textDecorationThickness: '2px' },
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
}));

const brackets = { '(': ')', '[': ']', '{': '}', '（': '）', '「': '」', '『': '』', '【': '】', '〈': '〉', '《': '》', '“': '”', '‘': '’' };
const closing = new Set(Object.values(brackets));
function urlText(candidate) {
  const stack = [];
  let end = 0;
  for (let index = 0; index < candidate.length; index += 1) {
    const character = candidate[index];
    if (closing.has(character)) {
      if (stack.pop() !== character) break;
    } else if (brackets[character]) stack.push(brackets[character]);
    end = index + 1;
  }
  while (end > 0 && (/[.,!?;:]/.test(candidate[end - 1]) || brackets[candidate[end - 1]])) end -= 1;
  return candidate.slice(0, end);
}
function linkText(text, className) {
  const expression = /https?:\/\/[^\s<>"'`。、！？，；：]+/gi;
  const parts = [];
  let cursor = 0;
  let match;
  while ((match = expression.exec(text)) !== null) {
    // Do not turn the tail of another scheme or an ASCII token into a link.
    if (match.index && /[A-Za-z0-9_+./:%-]/.test(text[match.index - 1])) continue;
    const value = urlText(match[0]);
    expression.lastIndex = match.index + value.length;
    try {
      const parsed = new URL(value);
      if (!['http:', 'https:'].includes(parsed.protocol)) continue;
    } catch (error) { continue; }
    parts.push(text.slice(cursor, match.index));
    parts.push(<a key={`url-${match.index}`} className={className} href={value} target="_blank" rel="noopener noreferrer">{value}</a>);
    cursor = expression.lastIndex;
  }
  parts.push(text.slice(cursor));
  return parts;
}

export default function BlogBodyText({ text = '' }) {
  const classes = useStyles();
  return <>{text.split(/\r?\n\s*\r?\n/).map((paragraph, index) => <Typography key={index} component="p" className={classes.paragraph}>
    {linkText(paragraph, classes.link)}
  </Typography>)}</>;
}
